import { useTranslation } from 'react-i18next';
import CustomButton from '../../components/CustomButton';
import PageHeader from '../../components/PageHeader';
import PageHeadline from '../../components/PageHeadline';

/**
 * Shown when the access-management route could not find out whether the tenant
 * holds the add-on — `GET /admin/account` errored.
 *
 * It exists because the alternative was a spinner with no way out. On `fun` the
 * route rendered an empty `<main>` with a spinner in it and nothing else: no
 * message, no empty state, no retry, so a real failure was indistinguishable
 * from a slow one and there was nothing for the operator to report (QA #2439,
 * defect B). That is the "A Failure Must Never Look Like an Absence" rule, in
 * the shape CLAUDE.md warns it usually takes — not hardware, a screen.
 *
 * It deliberately does NOT guess. Falling through to the device page would show
 * lockers to a tenant who may not have the add-on; falling through to the
 * upsell would sell it to one who already pays for it, which is exactly what
 * ADR-0001 Amendment 4 forbids. So it says what happened and offers the one
 * action that can change it.
 */
export default function AccessManagementUnavailable() {
    const { t } = useTranslation();

    return (
        <div>
            <PageHeader>
                <PageHeadline>{t('side_bar.access_management')}</PageHeadline>
            </PageHeader>
            <div className={'max-w-2xl rounded-[5px] bg-text-contrast p-5 shadow-sm'}>
                <p className={'text-sm text-foreground'}>
                    {t('access_management_unavailable.message')}
                </p>
                <p className={'mt-2 text-sm text-foreground/60'}>
                    {t('access_management_unavailable.hint')}
                </p>
                <div className={'mt-4'}>
                    <CustomButton
                        title={t('common.reload')}
                        onClick={() => window.location.reload()}
                    />
                </div>
            </div>
        </div>
    );
}
